import { useState, useEffect, useContext } from 'react'
import dynamic from 'next/dynamic'
import { InsuranceProviderContext } from 'context/common/InsuranceProvider'
import { filterTitle, sessionStorageKeys } from 'constants/common'
import HeaderFilterButton from 'app/ProviderSearch/HeaderFilterButton'
import styles from './index.module.scss'
import { ProviderHeaderFilterTypes } from 'dataSource/ProviderSearch'
const InsuranceSelectionDropdown = dynamic(
  () =>
    import(
      'app/ProviderSearch/HeaderFilter/InsuranceFilter/InsuranceSelectionDropdown'
    )
)

type InsuranceFilterProps = {
  onFilterSelect: (selectedFilter: Record<string, string>) => void
  containerClassName?: string
}

const InsuranceFilter: React.FC<InsuranceFilterProps> = ({
  onFilterSelect,
  containerClassName = '',
}) => {
  const [showInsuranceDropdown, setShowInsuranceDropdown] = useState<boolean>(
    false
  )
  const insuranceProviderContext = useContext(InsuranceProviderContext)
  const [insuranceDisplayValue, setInsuranceDisplayValue] = useState<string>('')

  useEffect(() => {
    const { insuranceDisplayValue } = insuranceProviderContext
    setInsuranceDisplayValue(insuranceDisplayValue)
  }, [insuranceProviderContext.insuranceDisplayValue])

  const onSelect = (insuranceProvider: InsuranceProvider, selfPay: boolean) => {
    sessionStorage.setItem(
      sessionStorageKeys.INSURANCE_PROVIDER_NAME,
      selfPay ? null : insuranceProvider.name
    )

    if (selfPay) {
      onFilterSelect({
        insuranceId: null,
      })

      setInsuranceDisplayValue('')
    } else {
      onFilterSelect({
        insuranceId: insuranceProvider?.id,
      })

      setInsuranceDisplayValue(insuranceProvider.name)
    }
  }

  return (
    <HeaderFilterButton
      title={filterTitle.INSURANCE}
      showDropdown={showInsuranceDropdown}
      setShowDropdown={setShowInsuranceDropdown}
      filterType={ProviderHeaderFilterTypes.INSURANCE}
      containerClassName={containerClassName}
      buttonClassName={styles.insurance_filter_button}
      text={insuranceDisplayValue}
      placeHolder="My insurance is..."
      mobilePlaceHolder={filterTitle.INSURANCE}
    >
      <InsuranceSelectionDropdown
        insuranceDisplayValue={insuranceDisplayValue}
        closeDropdown={() => setShowInsuranceDropdown(false)}
        onSelect={onSelect}
        dropdownClass="top-6 mt-5"
      />
    </HeaderFilterButton>
  )
}

export default InsuranceFilter
